import _ from "lodash";
import { angularJsApp } from "../app";
import { DATA_CENTRE, DATA_COMARCA, DATA_DISTRICTE, DATA_LIST_CENTRES, DATA_MUNICIPI, DATA_SERVEIS_TERRITORIAL } from "./data.service.constants";
import { AppServicesEnum } from "../app.model";
import { ICentre, IComarca, IData, IDistricte, IMunicipi, IServeiTerritorial } from "./api.model";

export class DataService {
  public listCentres = DATA_LIST_CENTRES;
  public listEstudisVacants: { estudis: any[]; totalItems: number } = { estudis: [], totalItems: 0 };
  public cercarPer = 1;
  public centre: ICentre = DATA_CENTRE;
  public municipi: IMunicipi = DATA_MUNICIPI;
  public comarca: IComarca = DATA_COMARCA;
  public serveisTerritorial: IServeiTerritorial = DATA_SERVEIS_TERRITORIAL;
  public districte: IDistricte = DATA_DISTRICTE;

  constructor() { }

  getData(): IData {
    return {
      cercarPer: this.cercarPer,
      centre: this.centre,
      municipi: this.municipi,
      comarca: this.comarca,
      serveisTerritorial: this.serveisTerritorial,
      districte: this.districte,
    };
  }

  getFilter(): string {
    const arrFilters: { codi: string; label: string }[] = [];
    let filter = "";

    if (this.municipi?.codiMunicipi) {
      arrFilters.push({ codi: this.municipi.codiMunicipi, label: this.municipi.labelFilter });
    }
    if (
      this.serveisTerritorial?.codiServeiTerritorial &&
      this.serveisTerritorial.codiServeiTerritorial !== "9900"
    ) {
      arrFilters.push({
        codi: this.serveisTerritorial.codiServeiTerritorial,
        label: this.serveisTerritorial.labelFilter,
      });
    }
    if (this.comarca?.codiComarca) {
      arrFilters.push({ codi: this.comarca.codiComarca, label: this.comarca.labelFilter });
    }
    if (this.districte?.codiDistricte) {
      arrFilters.push({ codi: this.districte.codiDistricte, label: this.districte.labelFilter });
      arrFilters.push({ codi: "08019", label: this.municipi?.labelFilter });
    }

    if (arrFilters.length > 0) {
      filter += " (";
      arrFilters.forEach((v, i) => {
        if (i !== 0) filter += " AND ";
        if (v.label === "CODI_SERVEI_TERRITORIAL") {
          const codi = (v.codi || "").split(",").map((val) => `'${val}'`).join(",");
          filter += `${v.label} IN (${codi || `'${v.codi}'`})`;
        } else {
          filter += `${v.label}='${v.codi}' `;
        }
      });
      filter += " ) ";
    }

    return filter;
  }

  reset(): void {
    this.cercarPer = 1;
    this.centre = {
      codiCentre: "",
      nomCentre: "",
      coordX: "",
      coordY: "",
      labelFilter: "CODI_CENTER",
      labelNomFilter: "NOM_CENTER",
      typeAheadFlag: false,
      typeaheadMinLength: 1,
      readonly: false,
      hideValidation: true,
      inputGroupClass: ''
    };
    this.municipi = {
      codiMunicipi: "",
      nomMunicipi: "",
      bbox: "",
      labelFilter: "CODI_MUNICIPI",
      typeAheadFlag: false,
      readonly: false,
      hideValidation: true,
      inputGroupClass: ''
    };
    this.comarca = {
      codiComarca: "",
      nomComarca: "",
      bbox: "",
      labelFilter: "CODI_COMARCA",
      typeAheadFlag: false,
      readonly: false,
      hideValidation: true,
      inputGroupClass: ''
    };
    this.serveisTerritorial = {
      codiServeiTerritorial: "",
      nomServeiTerritorial: "",
      bbox: "",
      labelFilter: "CODI_SERVEI_TERRITORIAL",
      typeAheadFlag: false,
      readonly: false,
      hideValidation: true,
      inputGroupClass: ''
    };
    this.districte = {
      codiDistricte: "",
      nomDistricte: "",
      bbox: "",
      labelFilter: "CODI_DISTRICTE",
      typeAheadFlag: false,
      readonly: false,
      hideValidation: true,
      inputGroupClass: ''
    };
    this.listCentres = {
      centres: [],
      totalItems: 0
    };
  }

  getAllEstudisByCodiCentre(codiCentre: string): any[] {
    return this.listEstudisVacants.estudis.filter((item) => item.codiCentre === codiCentre);
  }
}

angularJsApp.service(AppServicesEnum.DATA_SERVICE, DataService);

